import React, { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Login } from "./route/Login";
import { SignUp } from "./route/SignUp";
import { CouponV2 } from "./route/CouponV2";
import { Header } from "./component/common/Header";
import { CouponDownload } from "./route/CouponDownload";
import { Admin } from "./route/Admin";
import { ProductDetail } from "./route/ProductDetail";
import { Agreement } from "./route/Agreement";
import { Company } from "./route/Company";
import ReactGA from "react-ga4";
import { MainCategoryFilter } from "./route/MainCategoryFilter";
import { HomeV4 } from "./route/HomeV4";
import AiaEvent1 from "./route/aiapp/AiaEvent1";
import AiaCoupon from "./route/aiapp/AiaCoupon";
import styled from "styled-components";
import { AdAdmin } from "./component/admin-ad/AdAdmin";
import { AdUploader } from "./component/admin-ad/AdUploader";
import { AiaCouponDisplay } from "./route/aiapp/AiaCouponDisplay";

import Whiskey from "./component/whisky365/Whisky";
import { MerchandiseList } from "./component/whisky365/MerchandiseList";
import { Feedback } from "./component/whisky365/Feedback";
import { MyPage } from "./component/whisky365/MyPage";
import { SignUpBsdf } from "./component/whisky365/sign-up/SignUpBsdf";
import { LoginBsdf } from "./component/whisky365/sign-up/LoginBsdf";
import { FindPassword } from "./route/set-pw/findPassword";
import { ResetPassword } from "./route/set-pw/resetPassword";
import { AdDetails } from "./component/admin-ad/AdDetails";
import { MainBannerAdminPage } from "./component/admin/main-banner/MainBannerAdminPage";
import { AiSearchPage } from "./route/ai-search/aisearch";
import AdminV2 from "./route/AdminV2";

ReactGA.initialize("G-1CB0ZSGML5", { debug: true }); // react-ga 초기화 및 debug 사용

function App() {
  const location = useLocation();
  const [isBottomBarVisible, setIsBottomBarVisible] = useState(true);

  useEffect(() => {
    const noBottomBarRoutes = [
      "/admin",
      "/login",
      "/sign-up",
      "/find-password",
      "/reset-password",
      "/event/dfp-coupon",
      "/aiapp/dfp-coupon-page",
      "/aiapp/aia-coupon-display",
    ];

    const shouldShow = !noBottomBarRoutes.some((route) =>
      location.pathname.startsWith(route)
    );
    setIsBottomBarVisible(shouldShow);
  }, [location]);

  const Container = styled.div`
    min-height: 100vh; /* 페이지 전체를 포함하도록 최소 높이 설정 */
    display: flex;
    flex-direction: column; /* 플렉스 방향을 열로 설정 */
  `;

  return (
    <Container>
      <Header></Header>
      <Routes>
        <Route path="/" element={<HomeV4 />} />
        <Route path="/coupon/:couponId" element={<CouponDownload />} />
        <Route path="/coupon" element={<CouponV2 />} />
        <Route path="/admin123" element={<Admin />} />
        <Route path="/product/:productId" element={<ProductDetail />} />
        <Route path="/agreement/:agreementId" element={<Agreement />} />
        <Route path="/company/" element={<Company />} />
        <Route
          path="/mainCategoryFilter"
          element={<MainCategoryFilter />}
        ></Route>

        {/* 어드민 */}
        <Route path="/adminad/" element={<AdAdmin />} />
        <Route path="/uploadad/" element={<AdUploader />} />
        <Route path="/details/" element={<AdDetails />} />
        <Route path="/admin/" element={<AdDetails />} />

        {/* 어드민 v2 */}
        <Route path="/admin/main-banner" element={<MainBannerAdminPage />} />

        {/* AIA 이벤트 */}
        <Route path="/AiaCouponDisplay" element={<AiaCouponDisplay />} />
        {/* 일반 이벤트 */}
        <Route path="/event1/" element={<AiaEvent1 />} />
        <Route path="/eventCoupon/" element={<AiaCoupon />} />
        {/* 로그인 */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/admin-v2/*" element={<AdminV2 />} />

        {/* bsdf 로그인 관련 */}
        <Route path="/signupbsdf" element={<SignUpBsdf />} />
        <Route path="/loginbsdf" element={<LoginBsdf />} />
        {/* whisky365 */}
        <Route path="/whisky365" element={<MerchandiseList />} />
        <Route path="/whisky365/:productId" element={<Whiskey />} />
        <Route path="/whisky365/review" element={<Feedback />} />

        {/* My Page */}
        <Route path="/mypage" element={<MyPage />} />

        {/* reset PW */}
        <Route path="/findPassword" element={<FindPassword />} />
        <Route path="/resetPassword" element={<ResetPassword />} />

        {/* AI 검색 */}
        <Route path="/aisearch" element={<AiSearchPage />} />
      </Routes>
    </Container>
  );
}

export default App;
